import { z } from 'zod';

const PageNumber = z.coerce.number().int().positive();

export { PageNumber };
